export default [
  {
    component: 'CNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
    requiresSuperuser: false,
  },
  {
    component: 'CNavTitle',
    name: 'Kundenverwaltung',
    requiresSuperuser: true,
  },
  {
    component: 'CNavItem',
    name: 'Kunden',
    to: '/admin/user',
    icon: 'cil-people',
    requiresSuperuser: true,
  },
  {
    component: 'CNavItem',
    name: 'Einzahlungen',
    to: '/admin/portfolios',
    icon: 'cil-wallet',
    requiresSuperuser: true,
  },
  {
    component: 'CNavItem',
    name: 'Transaktionen',
    to: '/admin/transactions',
    icon: 'cil-transfer',
    requiresSuperuser: true,
  },
  {
    component: 'CNavItem',
    name: 'Gebühren',
    to: '/admin/fees',
    icon: 'cil-calculator',
    requiresSuperuser: true,
  },
  {
    component: 'CNavItem',
    name: 'Steuerreport',
    to: '/admin/taxes',
    icon: 'cil-file',
    requiresSuperuser: false,
  },
  {
    component: 'CNavTitle',
    name: 'Crypto Ratings',
    requiresSuperuser: true,
  },
  {
    component: 'CNavItem',
    name: 'Dashboard',
    to: '/rf/dashboard-rf',
    icon: 'cil-speedometer',
    requiresSuperuser: true,
  },
  {
    component: 'CNavItem',
    name: 'Neues Rating',
    to: '/rf/rating',
    icon: 'cil-notes',
    requiresSuperuser: true,
  },
  {
    component: 'CNavItem',
    name: 'Datenbank',
    to: '/rf/database-rf',
    icon: 'cil-puzzle',
    requiresSuperuser: true,
  },
  {
    component: 'CNavTitle',
    name: 'Adminverwaltung',
    requiresSuperuser: true,
  },
  {
    component: 'CNavItem',
    name: 'Admins',
    to: '/admin/admin',
    icon: 'cil-people',
    requiresSuperuser: true,
  },

]
